module.exports = __webpack_public_path__ + "static/media/program2outline.8ef31ca5.svg";